import { Tabs } from '../../model';

interface IRenderConditions {
  shouldRenderDescriptionTab: boolean;
  shouldRenderLivestreamsTab: boolean;
}

export const getDefaultTab = ({
  shouldRenderDescriptionTab,
  shouldRenderLivestreamsTab,
}: IRenderConditions) => {
  if (shouldRenderLivestreamsTab) {
    return Tabs.Livestreams;
  }

  if (shouldRenderDescriptionTab) {
    return Tabs.Description;
  }

  return Tabs.AboutBrand;
};
